module.exports = __webpack_public_path__ + "static/media/small-phone.8fd70f25.svg";